// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2UGgh","description":"PatientConsentPreview_description__2CDbB"};